// extracted by mini-css-extract-plugin
export default {"letterBoard":"InputArea_letterBoard__lvXDG"};